// payment/terms/agreement 결제 진행동의 페이지
import React from "react";
import "./PaymentAgreementPage.css";

const PaymentAgreementPage: React.FC = () => {
  return (
    <div className="payment-agreement">
      <div className="agreement-header">
        <h1>결제 진행 동의</h1>
        <p>서비스 이용을 위해 아래 약관을 확인해 주세요.</p>
      </div>

      <div className="agreement-content">
        {/* 개인정보 수집 및 이용 안내 */}
        <div className="agreement-section">
          <h2>개인정보 수집 및 이용 안내</h2>

          <div className="agreement-detail">
            <h3>[만세력 프리미엄 사주 개인정보 수집 및 이용 안내]</h3>
            <p>
              이규호사주TV(이하 '회사'라 한다)는 고객님의 개인정보를 소중히
              관리하며, 개인정보보호 관련 법령을 준수하여 아래와 같이
              처리합니다.
            </p>

            <div className="detail-item">
              <h4>1. 수집항목</h4>
              <p>생년월일, 태어난시간, 성별, 휴대폰번호, 이메일주소</p>
            </div>

            <div className="detail-item">
              <h4>2. 개인정보의 수집 목적</h4>
              <ul>
                <li>프리미엄 사주 영상 제공</li>
                <li>오류 문의 등 고객지원 및 운영</li>
                <li>프리미엄 사주 콘텐츠 발송 및 안내</li>
              </ul>
            </div>

            <div className="detail-item">
              <h4>3. 개인정보의 보유 및 이용 기간</h4>
              <ul>
                <li>운세 콘텐츠 제공 및 고객지원 : 30일</li>
                <li>
                  서비스 품질 개선 및 고객 관리 목적 : 최대 5년 보관 후 파기
                </li>
              </ul>
            </div>

            <div className="notice">
              <p>
                ※ 개인정보 수집 및 이용에 대해서는 거부 할 수 있으며, 거부
                시에는 서비스 이용이 불가능합니다.
              </p>
            </div>
          </div>
        </div>

        {/* 결제 이용 약관 */}
        <div className="agreement-section">
          <h2>결제 이용 약관</h2>

          <div className="agreement-detail">
            <h3>[결제 이용 약관]</h3>

            <div className="detail-item">
              <h4>
                ○ 구매하신 만세력 프리미엄 사주 중 영상 사주는 구매일로부터
                24시간 이내에 전송한 이메일에서 다운로드 받을 수 있는 기간동안
                이용하실 수 있습니다.
              </h4>
            </div>

            <div className="detail-item">
              <h4>○ 만세력 프리미엄 사주 청약 철회</h4>
              <ul>
                <li>
                  만세력 프리미엄 사주 서비스(전화 사주 및 영상사주)를 이용하지
                  않은 상태에서 결제 후 7일 이내에 취소 및 환불을 할 수
                  있습니다. 단, 결제 후 전화 사주 서비스를 받은 경우에는 취소 및
                  환불이 불가능합니다. 또한, 서비스의 특성상 단순 불만족에 의한
                  환불은 불가합니다.
                </li>
                <li>
                  취소 및 환불은 카카오톡 채널, 전화 등으로 이규호사주TV(이하
                  '회사'라 한다)에 그 의사를 표시한 때에 효력이 발생합니다.
                </li>
                <li>
                  회사는 회원에게 취소 및 환불의 의사표시에 대하여 회신한
                  날로부터 3영업일 이내에 대금의 결제와 동일한 방법으로 이를
                  환급하여야 하며, 동일한 방법으로 환불이 불가능할 때에는 이를
                  사전에 고지하여야 합니다. 다만, 수납확인이 필요한 결제수단의
                  경우에는 수납확인일로부터 3영업일 이내에 이를 환급하도록
                  합니다.
                </li>
              </ul>
            </div>

            <div className="detail-item">
              <h4>
                ○ 만세력 프리미엄 사주 서비스 이용 중 오류 발생시, 고객센터로
                해당 내용을 전달해 주시면 처리해드립니다.
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentAgreementPage;
